export default "__VITE_ASSET__DoqGilx5__"